export default __webpack_public_path__ + "static/media/check_this_out.b67633b3.gif";